import client from '../../client'
import { CampaignCode, Campaign } from './types'
import { ApiResponse } from '../../types'

export * from './types'

export const get = async (code: CampaignCode): Promise<Campaign | null> => {
  const { data }: ApiResponse<Campaign> = await client.get(
    `/user/campaigns/${code}`
  )
  return data
}
